import React from "react";
import { useShop } from "../../../Providers/ShopProvider";
import { useNavigate } from "react-router"

const Supplier = ({ supplier, image }) => {
    const navigate = useNavigate()
    const { setProductsFilter } = useShop()
    const handleSupplierClick = () => {
        setProductsFilter(prev => ({
            ...prev,
            Suppliers: [{ supplierId: supplier.supplierId, supplierName: supplier.supplierName }]
        }))
        navigate('/shop')
    }
    return (
        <div className="ProductPage-slider-container background-transparent align-content-center display-grid align-items-center element-pointer" onClick={() => handleSupplierClick()}>
            <div className="col display-flex">
                <img src={image} alt="Product" className="product-page-image mt-0" onError={(e) => { e.target.style = 'display:none' }} />
            </div>
        </div>
    )
}

export default Supplier